import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function clearArchiveExperience(): RootActionTypes {
  return {
    type: ActionTypes.CLEAR_ARCHIVE_EXPERIENCE,
  };
}
